import {
  Briefcase,
  Building2,
  ClipboardList,
  HelpCircle,
  Home,
  MessageSquare,
  Settings as SettingsIcon,
  Wallet,
} from 'lucide-react';
import type { NavItem } from 'shared/components/AppShell';
import { paths } from 'shared/routing/paths';

export interface ExpertNavCounts {
  assignedJobsCount?: number;
  unreadMessagesCount?: number;
}

function labelWithCount(label: string, count: number | undefined): string {
  return count !== undefined && count > 0 ? `${label} (${count})` : label;
}

export function getExpertNav(counts: ExpertNavCounts = {}): NavItem[] {
  return [
    { label: 'Home', to: paths.expert.root, icon: Home },
    { label: 'Campaigns', to: paths.expert.campaigns, icon: Briefcase },
    { label: labelWithCount('My Jobs', counts.assignedJobsCount), to: paths.expert.assigned, icon: ClipboardList },
    { label: 'Earnings', to: paths.expert.earnings, icon: Wallet },
    { label: 'Partner Access', to: paths.expert.partnerAccess, icon: Building2 },
    { label: labelWithCount('Messages', counts.unreadMessagesCount), to: paths.expert.messageBoard, icon: MessageSquare },
    { label: 'Help Center', to: paths.expert.knowledgeBase, icon: HelpCircle },
    { label: 'Settings', to: paths.expert.settingsPersonal, icon: SettingsIcon },
  ];
}

/** Static labels used by consumers that do not need live sidebar counts. */
export const EXPERT_NAV: NavItem[] = getExpertNav();
